import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { siteInfo } from '@/mocks/site';

const footerLinks = [
  {
    title: '快速导航',
    links: [
      { label: '首页', href: '/' },
      { label: '关于我们', href: '/about' },
    ],
  },
  {
    title: '内容分类',
    links: categories.map((cat) => ({
      label: cat.name,
      href: `/category/${cat.slug}`,
    })),
  },
  {
    title: '联系方式',
    links: [
      { label: `邮箱：${siteInfo.contactInfo.email}`, href: `mailto:${siteInfo.contactInfo.email}` },
      { label: `微信：${siteInfo.contactInfo.wechat}`, href: '#' },
      { label: `微博：${siteInfo.contactInfo.weibo}`, href: '#' },
      { label: siteInfo.contactInfo.workingHours, href: '#' },
    ],
  },
];

export default function Footer() {
  const organizationJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: siteInfo.name,
    url: siteInfo.url,
    description: siteInfo.description,
    email: siteInfo.contactInfo.email,
    foundingDate: siteInfo.foundingYear,
    contactPoint: {
      '@type': 'ContactPoint',
      email: siteInfo.contactInfo.email,
      contactType: 'customer service',
      availableLanguage: ['Chinese'],
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(organizationJsonLd)}</script>
      <footer className="bg-background-900 text-foreground-50">
        <div className="px-4 md:px-6 py-12">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
              <div>
                <div className="flex items-center gap-2 mb-4">
                  <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                    <i className="ri-tv-2-line text-lg text-white"></i>
                  </div>
                  <span className="text-lg font-bold font-heading text-white">
                    {siteInfo.name}
                  </span>
                </div>
                <p className="text-sm text-foreground-300 leading-relaxed mb-4">
                  {siteInfo.tagline}
                </p>
                <div className="flex items-center gap-3">
                  <a href="#" className="w-8 h-8 flex items-center justify-center rounded-md bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微博">
                    <i className="ri-weibo-line text-sm"></i>
                  </a>
                  <a href="#" className="w-8 h-8 flex items-center justify-center rounded-md bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微信">
                    <i className="ri-wechat-line text-sm"></i>
                  </a>
                  <a href={`mailto:${siteInfo.contactInfo.email}`} className="w-8 h-8 flex items-center justify-center rounded-md bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="邮箱">
                    <i className="ri-mail-line text-sm"></i>
                  </a>
                </div>
              </div>

              {footerLinks.map((section, idx) => (
                <div key={idx}>
                  <h4 className="text-sm font-semibold text-white mb-4 font-heading">
                    {section.title}
                  </h4>
                  <ul className="space-y-2.5">
                    {section.links.map((link, linkIdx) => (
                      <li key={linkIdx}>
                        {link.href.startsWith('mailto:') || link.href === '#' ? (
                          <a
                            href={link.href}
                            className="text-sm text-foreground-300 hover:text-primary-300 transition-colors"
                            {...(link.href === '#' ? {} : {})}
                          >
                            {link.label}
                          </a>
                        ) : (
                          <Link
                            to={link.href}
                            className="text-sm text-foreground-300 hover:text-primary-300 transition-colors"
                          >
                            {link.label}
                          </Link>
                        )}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>

            <div className="mt-10 pt-6 border-t border-background-700">
              <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
                <p className="text-xs text-foreground-400">
                  &copy; {new Date().getFullYear()} {siteInfo.name} 版权所有
                </p>
                <div className="flex items-center gap-4">
                  <a href="#" className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors">隐私政策</a>
                  <a href="#" className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors">使用条款</a>
                  <a href="#" className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors">免责声明</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}